var version = '6.7.2';

module.exports = version;
